export default __webpack_public_path__ + "static/media/playering2.cb965ca2.png";